/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const common = pickLocale(ar.common, en.common)
export const settingsStrings = pickLocale(ar.settingsStrings, en.settingsStrings)
export const advancedStrings = pickLocale(ar.advancedStrings, en.advancedStrings)
export const settingsKeysStrings = pickLocale(ar.settingsKeysStrings, en.settingsKeysStrings)
